<div class="container-fluid custom-bg-v4">
  <h4 class="font-bold">{{ "Search filter" | translator }}</h4>
  <div class="d-flex row">
    <div class="col-md-12 col-12 my-2">
      <div class="col-md-12 col-sm-12 col-12">
        <div class="w-100 p-input-icon-left">
          <input
            class="w-100 q-input-white"
            placeholder="بحث"
            type="text"
            pInputText
            [(ngModel)]="serchFilter"
          />
          <!-- <i class="pi pi-search"></i> -->
        </div>
      </div>
    </div>
    <!-- <div class="col-md-3 col-12">
        <div class="col-md-12 col-sm-12 col-12">
            <p-dropdown [options]="ouTypes" [(ngModel)]="typeFilter"  appendTo="body"
                placeholder='{{"Select the type"| translator}}' [filter]="true"
                styleClass=" sstarabic w-100">
                <ng-template let-item pTemplate="item">
                    <i [ngClass]="item.icon"></i>
                    {{item.label}}
                </ng-template>
            </p-dropdown>
        </div>
    </div> -->

    <div class="col-md-8 col-12 pt-2">
      <p-treeSelect
        appendTo="body"
        class="v4-tree w-100"
        containerStyleClass="w-100"
        [(ngModel)]="ouFilter"
        [options]="selectedTreeData"
        placeholder="{{
          'Classification of the services of the entity' | translator
        }}"
        [filter]="true"
        [filterInputAutoFocus]="true"
        (onNodeSelect)="filterFunctionByPostOuFilter($event)"
      >
        <ng-template let-node pTemplate="default">
          <div class="d-flex">
            <img
              *ngIf="checkisImg(node.data); else elseBlock"
              src="{{ staticURL }}{{ node.data }}"
              class="img-fluid p-1 tree-img-bg"
              style="max-height: 30px; max-width: 30px"
            />
            <ng-template #elseBlock>
              <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
            </ng-template>
            <b class="text-nowrap">{{ node.label }}</b>
          </div>
        </ng-template>
      </p-treeSelect>
    </div>

    <div class="col-md-4 col-12 d-flex justify-content-end gap-3">
      <div class="d-flex">
        <p-button class="v4-btn-every-v4 py-2 m-1 22" (onClick)="resetFilters()">{{
          "Reset" | translator
        }}</p-button>
        <p-button
          class="v4-btn-every-v4 py-2 m-1 11"
          [loading]="loadingFilters"
          [disabled]="loadingFilters"
          (click)="getData()"
          >{{ "search" | translator }}</p-button
        >
      </div>
    </div>
  </div>

  <!-- <div class="row">
    <div
        class="col-9 offset-3 d-flex justify-content-between flex-start mob-flex-column my-2 mb-4 p-right-2rem">
        <h2 class="card-title manage-margin" style="font-weight: 600; color: var(--color-1)">
            {{currentview.name}}</h2>
        <div class="d-flex">
            <span class="btn-flex mx-1">
                <span class="d-flex flex-column">
                    <span class="btn-css mx-2">{{"Last updated"| translator}}</span>
                    <span class="btn-css mx-2 font-0_8rem font-weight-200">
                        {{currentview.updatedAt | date:'MMMM,d, y | h:mm:ss a'}}
                    </span>
                </span>
                <span class="icon-box">
                    <i class="pi pi-calendar font-500"></i>
                </span>
            </span>
        </div>
    </div>

</div> -->

  <!-- skelition   -->
  <app-skelitions
    [hidden]="!skelition"
    [value]="2"
    class="mb-2"
  ></app-skelitions>
  <!-- skelition  END -->

  <div [hidden]="skelition || firstSearch" class="row ms-bg-2">
    <div class="col-12 d-flex justify-content-start wrapp my-4">
      <div
        class="custom-cat-btn"
        style="cursor: pointer"
        *ngFor="let n of data_types"
        (click)="applyTypeFilter(n?.name)"
        [ngClass]="currentTypeFilter == n?.name ? 'active' : ''"
      >
        <span class="custom-cat-btn-num">{{
          counter(n?.name).toString()
        }}</span>
        <span><i class="pi-fw {{ n?.icon }} mx-2 icon-1-2rem"></i></span>
        <span>{{ n?.arabic }}</span>
      </div>
    </div>

    <div class="col-md-4 col-12 my-2 poss-rel">
      <span class="circle-numer">
        <span
          *ngFor="let i of pages"
          class="circle-num-ui"
          [ngClass]="currentPage == changeToNumber(i) ? 'active' : ''"
          (click)="currentPage = changeToNumber(i); changePage(currentPage)"
          >{{ i }}</span
        >
      </span>

      <div class="card border-none card-mobile-alignment ms-bg">
        <div class="d-flex justify-content-between align-items-center user-category">
          <div class="custom-pagination-text d-flex"> 
            <div class="l">{{ "results" | translator }}</div>
            <br />
            <div class="l">{{ currentPage }} - {{ first + rows > totalRecords ? totalRecords : first + rows }}</div>
              <div class="l">{{ "from" | translator }} {{ totalRecords }}</div>
            </div>
          <div class="d-flex">
            <span class="custom-pagination" (click)="moveToLast(true)"
              ><i class="pi pi-fw pi-angle-double-right icon-x2"></i
            ></span>
            <span
              class="custom-pagination"
              (click)="changePage(currentPage - 1)"
              ><i class="pi pi-fw pi-angle-right icon-x2"></i
            ></span>
            <span
              class="custom-pagination"
              (click)="changePage(currentPage + 1)"
              ><i class="pi pi-fw pi-angle-left icon-x2"></i
            ></span>
            <span class="custom-pagination" (click)="moveToLast(false)"
              ><i class="pi pi-fw pi-angle-double-left icon-x2"></i
            ></span>
          </div>
        </div>

        <div class="d-flex py-3">
          <span class="p-float-label w-100 mt-3">
            <input
              type="text"
              id="float-label"
              class="w-100 mob-width"
              (keyup)="applyFilterGlobal($event, 'contains')"
              pInputText
              placeholder="{{ 'Find a name or number' | translator }}"
            />
            <label for="float-label">{{ "Discus" | translator }} </label>
          </span>
        </div>

        <p-dataView
          #dv
          [value]="filteredData"
          filterBy="name,fields.data,id,type.name,type.arabic,active"
          [rows]="10"
          [paginator]="true"
          [sortField]="sortField"
          [sortOrder]="sortOrder"
          (onPage)="onPageChange($event)"
          paginatorPosition="none"
          emptyMessage="{{ 'There is no data' | translator }}"
        >
          <ng-template let-item let-index="rowIndex" pTemplate="listItem">
            <span [hidden]="item.type.name == 'Licence'">
              <div
                class="list-item custom-w-90 d-flex flex-row flex-nowrap flex-wrap align-items-center"
                [ngClass]="currentview?.id == item.id ? 'activedd' : ''"
                (click)="changeView(item)"
              >
                <div class="">
                  <button class="num-btn m-2"
                  [ngClass]="currentview?.id == item.id ? 'num-btn-active' : ''"
                  >
                    
                    {{ index + 1 + (currentPage - 1) * 10 }}
                  </button>
                </div>
                <div>
                  <p class="mb-0 color-grey">{{ item.id }}</p>
                  <p>
                    <b class="color-grey">{{ item.name }}</b>
                  </p>
                </div>
              </div>
            </span>
          </ng-template>
        </p-dataView>
      </div>
    </div>

    <div
      class="col-md-8 col-12 my-2 v4-bg"
      *ngIf="
        currentview == undefined ||
        currentview == null ||
        currentview?.fields?.length == 0
      "
    >
      <!-- <app-no-data></app-no-data> -->
      <div class="container p-0">
        <div class="custom-my-10 bg-ui">
          <div class="row">
            <div class="col-md-1 col-2">
              <span class="pointer"
                ><i class="fa-regular fa-hand-point-right"></i
              ></span>
            </div>
            <div class="col-md-11 col-10 d-flex justify-content-center">
              <h2 class="text-center">
                <i
                  class="pi pi-fw pi-exclamation-triangle font-2rem v4-ml-2"
                ></i>
                {{ "click on item to view details" | translator }}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="currentview != null && currentview != undefined"
      class="col-md-8 col-12 my-2 v4-bg"
    >
      <div class="card border-none card-mobile-alignment ms-bg">
        <div class="row">
          <div class="col-md-8 col-12">
            <h2
              class="card-title color-grey 222"
              style="font-weight: 600;"
            >
              {{ currentview.name }}
            </h2>
          </div>
          <div class="col-md-4 col-12">
            <div class="d-flex justify-content-end">
              <span class="btn-flex mx-1">
                <span class="d-flex flex-column">
                  <span class="btn-css mx-2">{{
                    "Last updated" | translator
                  }}</span>
                  <span class="btn-css mx-2 font-0_8rem font-weight-200">
                    {{ currentview.updatedAt | date : "MMMM,d, y | h:mm:ss a" }}
                  </span>
                </span>
                <span class="icon-box">
                  <i class="pi pi-calendar font-500"></i>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- breadcrumb -->
        <div class="d-flex flex-row align-items-center wrapp">
          <span
            class="d-flex align-items-center my-1"
            *ngFor="let item of currentview.breadcrumbs; let i = index"
            [routerLink]="item.routerLink"
          >
            <span class="custom-bredcrum-btn d-flex align-items-center">
              <i [hidden]="item.image_sq" class="{{ item.icon }} me-1"></i>
              <img
                [hidden]="!item.image_sq"
                [src]="staticURL + item.image_sq"
                style="max-height: 1.2rem; max-width: 1.2rem"
                class="blacknWhite img-fluid me-1"
              />
              {{ item.label }}
            </span>
            <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
          </span>
        </div>
        <!-- breadcrumb end -->

        <div class="card card-bgg border-none w-100">
          <div class="card-body">
            <p-accordion class="w-full" [multiple]="true" [activeIndex]="0">
              <p-accordionTab
                class="my-3"
                *ngFor="let field of currentview.fields; let i = index"
                iconPos="end"
                [selected]="i == 0 || i == 1"
              >
                <ng-template pTemplate="header">
                  <div class="d-flex align-items-center">
                    <i
                      [ngClass]="field.label?.icon + ' font-1_2rem'"
                      class="m-2"
                    ></i>
                    <span class="vertical-align-middle font-1_1rem">{{
                      field.label?.name
                    }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="content">
                  <div *ngIf="i != editIndex" class="row">
                    <div class="col-10 py-2">
                      <div [ngSwitch]="getFieldType(field.label?.type)">
                        <!-- For text -->
                        <div *ngSwitchCase="'text'">
                          <div
                            class="d-flex flex-column mb-0 datacontent"
                            *ngIf="field.data"
                            [innerHTML]="field.data | safeHTML"
                          ></div>
                        </div>
                        <!-- Rich text -->
                        <div *ngSwitchCase="'Rich text'">
                          <div
                            class="d-flex flex-column mb-0 datacontent"
                            *ngIf="field.data"
                            [innerHTML]="field.data | safeHTML"
                          ></div>
                        </div>
                        <div *ngSwitchCase="'Upload Image'">
                          <img
                            [hidden]="field.data == ''"
                            class="img-fluid upload-img"
                            [src]="GlobalConstants.staticFilesURL + field.data"
                          />
                        </div>
                        <div *ngSwitchCase="'Upload Document'">
                          <a
                            class="doc-view"
                            [hidden]="field.data == ''"
                            target="_blank"
                            [href]="GlobalConstants.staticFilesURL + field.data"
                          >
                            <i
                              [hidden]="field.data == ''"
                              class="pi pi-file mx-2"
                            ></i
                            >{{ "addition" | translator }}
                            {{ "file" | translator }}
                          </a>
                        </div>
                        <div *ngSwitchDefault>{{ field.data }}</div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>

        <div
          [hidden]="!currentview._id || skelition"
          class="my-3 px-3 d-flex justify-content-end"
        >
          <span class="mx-1" (click)="sendData()">
            <button class="success">
              <i class="pi pi-check-circle m-l-2 font-500 font-1_2rem"></i
              >{{ "Submit Request" | translator }}
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
